import { render, staticRenderFns } from "./personaPhysiologyPdf.vue?vue&type=template&id=d295a8f4&scoped=true&"
import script from "./personaPhysiologyPdf.vue?vue&type=script&lang=js&"
export * from "./personaPhysiologyPdf.vue?vue&type=script&lang=js&"
import style0 from "./personaPhysiologyPdf.vue?vue&type=style&index=0&id=d295a8f4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d295a8f4",
  null
  
)

export default component.exports